// Flipmax 7-Step Deal Submission Form
// Psychology-driven: micro-commitment → lead capture → progressive disclosure
// All state is client-side. Single webhook POST on final submit.
document.addEventListener('DOMContentLoaded', function() {
  const step1El = document.getElementById('step1');
  if (!step1El) return;

  // ── State ──
  const state = {
    currentStep: 1,
    referenceNumber: null,
    loanType: null,
    propertyType: null,
    formData: {},
    selections: { desiredTerm4A: '12', desiredTerm4C: '12', desiredTerm4D: '18' },
    tosTimestamp: null,
    creditAuthTimestamp: null
  };

  const TOTAL_STEPS = 7;
  let saveTimeout;

  // ── Reference Number Generator ──
  function generateReference() {
    const now = new Date();
    const date = now.getFullYear().toString() +
      String(now.getMonth() + 1).padStart(2, '0') +
      String(now.getDate()).padStart(2, '0');
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let suffix = '';
    for (let i = 0; i < 4; i++) suffix += chars.charAt(Math.floor(Math.random() * chars.length));
    return `FM-${date}-${suffix}`;
  }

  // ── Option Card Selection ──
  function initOptionCards(containerId, stateKey) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('.option-card').forEach(card => {
      card.addEventListener('click', function() {
        container.querySelectorAll('.option-card').forEach(c => {
          c.classList.remove('border-fx-primary', 'bg-fx-green-10');
          c.classList.add('border-gray-200');
        });
        this.classList.remove('border-gray-200');
        this.classList.add('border-fx-primary', 'bg-fx-green-10');
        state.selections[stateKey] = this.dataset.value;

        // Handle conditional UI
        if (stateKey === 'existingDebt') {
          document.getElementById('debtBalanceField').classList.toggle('hidden', this.dataset.value !== 'yes');
        }
        if (stateKey === 'didRenovate') {
          document.getElementById('renoInvestmentField').classList.toggle('hidden', this.dataset.value !== 'yes');
        }
        if (stateKey === 'occupancyStatus') {
          const redirect = document.getElementById('vacantRedirect');
          redirect.classList.toggle('hidden', this.dataset.value !== 'vacant');
        }
        if (stateKey === 'experienceTier') {
          const show = this.dataset.value === '1_to_2' || this.dataset.value === '3_plus';
          document.getElementById('sreoSection').classList.toggle('hidden', !show);
          if (show && document.querySelectorAll('.sreo-entry').length === 0) {
            addSreoEntry();
          }
        }
      });
    });
  }

  // Initialize all option card groups
  initOptionCards('loanTypeCards', 'loanType');
  initOptionCards('propertyTypeCards', 'propertyType');
  initOptionCards('termCards4A', 'desiredTerm4A');
  initOptionCards('occupancyCards', 'occupancyStatus');
  initOptionCards('existingDebtCards', 'existingDebt');
  initOptionCards('didRenovateCards', 'didRenovate');
  initOptionCards('cashOutCards', 'seekingCashOut');
  initOptionCards('termCards4C', 'desiredTerm4C');
  initOptionCards('termCards4D', 'desiredTerm4D');
  initOptionCards('experienceCards', 'experienceTier');
  initOptionCards('residencyCards', 'residencyStatus');

  // ── Step Navigation ──
  function goToStep(n) {
    // Hide all steps
    document.querySelectorAll('.step-container').forEach(el => el.classList.add('hidden'));

    // For step 4, route to correct sub-step
    let targetId;
    if (n === 4) {
      const lt = state.loanType;
      if (lt === 'fix_and_flip') targetId = 'step4A';
      else if (lt === 'rental_dscr') targetId = 'step4B';
      else if (lt === 'ground_up') targetId = 'step4D';
      else targetId = 'step4C';
    } else if (n === 8) {
      targetId = 'confirmation';
    } else {
      targetId = 'step' + n;
    }

    const target = document.getElementById(targetId);
    if (target) {
      target.classList.remove('hidden');
      // Trigger animation
      target.style.animation = 'none';
      target.offsetHeight; // reflow
      target.style.animation = '';
    }

    state.currentStep = n;
    updateProgressBar(n);
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Track with GA4
    if (typeof gtag === 'function') {
      gtag('event', 'form_step_viewed', {
        step_number: n,
        loan_type: state.loanType,
        reference_number: state.referenceNumber
      });
    }
  }
  window.fxForm = { goToStep: goToStep };

  function updateProgressBar(step) {
    const clamped = Math.min(step, TOTAL_STEPS);
    const pct = (clamped / TOTAL_STEPS) * 100;
    const bar = document.getElementById('progressBar');
    if (bar) bar.style.width = pct + '%';

    // Mobile label
    const mLabel = document.getElementById('mobileStepLabel');
    const mName = document.getElementById('mobileStepName');
    const names = ['Your Deal', 'You', 'Property', 'Details', 'Experience', 'Verify', 'Documents'];
    if (mLabel) mLabel.textContent = `Step ${clamped} of ${TOTAL_STEPS}`;
    if (mName && names[clamped - 1]) mName.textContent = names[clamped - 1];

    // Desktop dots
    for (let i = 1; i <= TOTAL_STEPS; i++) {
      const dot = document.getElementById('progressDot' + i);
      if (!dot) continue;
      const numEl = dot.querySelector('.step-number');
      const checkEl = dot.querySelector('.step-check');
      dot.classList.remove('bg-fx-primary', 'text-white', 'bg-gray-200', 'text-gray-500', 'bg-green-500');
      if (i < clamped) {
        dot.classList.add('bg-fx-primary', 'text-white');
        if (numEl) numEl.classList.add('hidden');
        if (checkEl) checkEl.classList.remove('hidden');
      } else if (i === clamped) {
        dot.classList.add('bg-fx-primary', 'text-white');
        if (numEl) numEl.classList.remove('hidden');
        if (checkEl) checkEl.classList.add('hidden');
      } else {
        dot.classList.add('bg-gray-200', 'text-gray-500');
        if (numEl) numEl.classList.remove('hidden');
        if (checkEl) checkEl.classList.add('hidden');
      }
    }

    // Hide progress on confirmation
    const progSection = document.getElementById('progressSection');
    if (progSection) progSection.classList.toggle('hidden', step >= 8);
  }

  // ── Validation Helpers ──
  function showError(id, msg) {
    const el = document.getElementById(id);
    if (el) { el.textContent = msg; el.classList.remove('hidden'); }
  }

  function clearErrors() {
    document.querySelectorAll('.error-message').forEach(el => el.classList.add('hidden'));
  }

  // ── API Helper ──
  async function apiPost(url, data) {
    try {
      const resp = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return await resp.json();
    } catch (e) {
      console.error('API error:', e);
      return { success: false, errors: ['Network error. Please try again.'] };
    }
  }

  // ── STEP 1: Micro-Commitment ──
  document.getElementById('step1Next').addEventListener('click', function() {
    clearErrors();
    if (!state.selections.loanType) { showError('loanTypeError', 'Please select a financing type'); return; }
    if (!state.selections.propertyType) { showError('propertyTypeError', 'Please select a property type'); return; }

    state.loanType = state.selections.loanType;
    state.propertyType = state.selections.propertyType;
    // A lock link from the public pricer (/apply/?quote=FM-Q-...) makes the
    // quote id the application reference so the LOS can tie the two together.
    const params = new URLSearchParams(window.location.search);
    const quoteId = (params.get('quote') || '').trim().toUpperCase();
    state.referenceNumber = /^FM-Q-\d{8}-[A-Z0-9]{4}$/.test(quoteId) ? quoteId : generateReference();

    // Capture UTM params
    state.formData.utmSource = params.get('utm_source') || '';
    state.formData.utmMedium = params.get('utm_medium') || '';
    state.formData.utmCampaign = params.get('utm_campaign') || '';

    // Pre-fill from homepage hero form if available
    try {
      const heroData = JSON.parse(localStorage.getItem('preapproval_contact_info') || '{}');
      if (heroData.firstName) {
        const el = document.getElementById('firstName');
        if (el && !el.value) el.value = heroData.firstName;
      }
      if (heroData.lastName) {
        const el = document.getElementById('lastName');
        if (el && !el.value) el.value = heroData.lastName;
      }
      if (heroData.phone) {
        const el = document.getElementById('phone');
        if (el && !el.value) el.value = heroData.phone;
      }
      if (heroData.email) {
        const el = document.getElementById('email');
        if (el && !el.value) el.value = heroData.email;
      }
    } catch (e) {}

    // Pre-fill from saved borrower contact info (persists across applications)
    try {
      const saved = JSON.parse(localStorage.getItem('flipmax_borrower_contact') || '{}');
      ['firstName', 'lastName', 'phone', 'email'].forEach(field => {
        const el = document.getElementById(field);
        if (el && !el.value && saved[field]) el.value = saved[field];
      });
    } catch (e) {}

    goToStep(2);
  });

  // ── STEP 2: Lead Capture ──
  document.getElementById('step2Form').addEventListener('submit', function(e) {
    e.preventDefault();
    clearErrors();

    const firstName = document.getElementById('firstName').value.trim();
    const lastName = document.getElementById('lastName').value.trim();
    const email = document.getElementById('email').value.trim();
    const phone = document.getElementById('phone').value.trim();
    const tos = document.getElementById('tosConsent').checked;

    let valid = true;
    if (!firstName) { showError('firstNameError', 'First name is required'); valid = false; }
    if (!lastName) { showError('lastNameError', 'Last name is required'); valid = false; }
    if (!email || !email.includes('@')) { showError('emailError', 'Valid email is required'); valid = false; }
    if (!phone || phone.replace(/\D/g, '').length < 10) { showError('phoneError', 'Valid phone number is required'); valid = false; }
    if (!tos) { showError('tosError', 'You must agree to the Terms of Service'); valid = false; }
    if (!valid) return;

    state.formData = { ...state.formData, firstName, lastName, email, phone };
    state.formData.tosConsent = true;
    state.tosTimestamp = new Date().toISOString();

    // Persist contact info for future applications
    localStorage.setItem('flipmax_borrower_contact', JSON.stringify({ firstName, lastName, email, phone }));

    goToStep(3);
  });

  // ── STEP 3: Property Address ──
  document.getElementById('step3Form').addEventListener('submit', function(e) {
    e.preventDefault();
    clearErrors();

    const addr = document.getElementById('propertyAddress').value.trim();
    if (!addr) { showError('propertyAddressError', 'Property address is required'); return; }

    state.formData.propertyAddress = addr;
    state.formData.propertyCity = document.getElementById('propertyCity').value;
    state.formData.propertyState = document.getElementById('propertyState').value;
    state.formData.propertyZip = document.getElementById('propertyZip').value;
    state.formData.propertyCounty = document.getElementById('propertyCounty').value;
    state.formData.googlePlaceId = document.getElementById('googlePlaceId').value;

    goToStep(4);
  });

  // ── STEP 4A: Fix & Flip ──
  document.getElementById('step4AForm').addEventListener('submit', function(e) {
    e.preventDefault();
    clearErrors();

    const pp = document.getElementById('purchasePrice').value.trim();
    const rb = document.getElementById('rehabBudget').value.trim();
    const arv = document.getElementById('arv').value.trim();

    if (!pp || !rb || !arv) { alert('Please fill in the required fields.'); return; }

    state.formData.purchasePrice = pp;
    state.formData.rehabBudget = rb;
    state.formData.arv = arv;
    state.formData.closingDate = document.getElementById('closingDate').value;
    state.formData.desiredTerm = state.selections.desiredTerm4A || '';

    goToStep(5);
  });

  // ── STEP 4B: Rental DSCR ──
  document.getElementById('step4BForm').addEventListener('submit', function(e) {
    e.preventDefault();
    clearErrors();

    const mr = document.getElementById('monthlyRent').value.trim();
    if (!mr) { alert('Monthly rent is required.'); return; }
    if (!state.selections.occupancyStatus) { showError('occupancyError', 'Please select occupancy status'); return; }

    state.formData.monthlyRent = mr;
    state.formData.currentLoanAmount = document.getElementById('currentLoanAmount').value.trim();
    state.formData.occupancyStatus = state.selections.occupancyStatus;

    goToStep(5);
  });

  // Vacant → Bridge redirect
  const redirectBtn = document.getElementById('redirectToBridge');
  if (redirectBtn) {
    redirectBtn.addEventListener('click', function() {
      state.loanType = 'bridge';
      goToStep(4); // Will now show 4C since loanType is bridge
    });
  }

  const keepRentalBtn = document.getElementById('keepRental');
  if (keepRentalBtn) {
    keepRentalBtn.addEventListener('click', function() {
      document.getElementById('vacantRedirect').classList.add('hidden');
    });
  }

  // ── STEP 4D: Ground-Up Construction ──
  const step4DForm = document.getElementById('step4DForm');
  if (step4DForm) {
    step4DForm.addEventListener('submit', function(e) {
      e.preventDefault();
      clearErrors();

      const lp = document.getElementById('lotPurchasePrice').value.trim();
      const cb = document.getElementById('constructionBudget').value.trim();
      const cv = document.getElementById('completedValue').value.trim();

      if (!lp || !cb || !cv) { alert('Please fill in the required fields.'); return; }

      // Reuse fix_and_flip field names so the LOS webhook payload stays the same.
      state.formData.purchasePrice = lp;
      state.formData.rehabBudget = cb;
      state.formData.arv = cv;
      state.formData.closingDate = document.getElementById('closingDateGU').value;
      state.formData.desiredTerm = state.selections.desiredTerm4D || '';

      goToStep(5);
    });
  }

  // ── STEP 4C: Bridge ──
  document.getElementById('step4CForm').addEventListener('submit', function(e) {
    e.preventDefault();
    clearErrors();

    const ev = document.getElementById('estimatedValue').value.trim();
    if (!ev) { alert('Estimated property value is required.'); return; }

    state.formData.existingDebt = state.selections.existingDebt || '';
    state.formData.existingDebtBalance = document.getElementById('existingDebtBalance').value.trim();
    state.formData.estimatedValue = ev;
    state.formData.didRenovate = state.selections.didRenovate || '';
    state.formData.renovationInvestment = document.getElementById('renovationInvestment').value.trim();
    state.formData.seekingCashOut = state.selections.seekingCashOut || '';
    state.formData.desiredTerm = state.selections.desiredTerm4C || '';

    goToStep(5);
  });

  // Step 5 back button routes to correct step 4
  document.getElementById('step5Back').addEventListener('click', function() {
    goToStep(4);
  });

  // ── SREO Property Builder ──
  let sreoIndex = 0;

  function addSreoEntry(data) {
    const container = document.getElementById('sreoEntries');
    const idx = sreoIndex++;
    const div = document.createElement('div');
    div.className = 'sreo-entry border-2 border-gray-200 rounded-xl p-4 pt-8 relative';
    div.dataset.index = idx;
    div.innerHTML = `
      <button type="button" class="sreo-remove absolute top-2 right-3 text-gray-400 hover:text-red-500 text-xl leading-none" title="Remove property">&times;</button>
      <div class="space-y-3">
        <div>
          <label class="block text-xs font-semibold text-gray-600 mb-1">Property Address</label>
          <input type="text" class="sreo-address w-full py-2.5 px-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-fx-primary text-sm" placeholder="123 Main St, City, ST 12345">
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label class="block text-xs font-semibold text-gray-600 mb-1">Purchase Price</label>
            <div class="relative">
              <span class="absolute left-3 top-2.5 text-gray-400 text-sm">$</span>
              <input type="text" inputmode="numeric" class="sreo-purchase-price currency-input w-full pl-7 pr-3 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-fx-primary text-sm" placeholder="250,000">
            </div>
          </div>
          <div>
            <label class="block text-xs font-semibold text-gray-600 mb-1">Rehab Amount</label>
            <div class="relative">
              <span class="absolute left-3 top-2.5 text-gray-400 text-sm">$</span>
              <input type="text" inputmode="numeric" class="sreo-rehab-amount currency-input w-full pl-7 pr-3 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-fx-primary text-sm" placeholder="45,000">
            </div>
          </div>
        </div>
        <div>
          <label class="block text-xs font-semibold text-gray-600 mb-1">Did you sale or rent this property?</label>
          <div class="grid grid-cols-3 gap-2 sreo-exit-cards">
            <button type="button" class="sreo-exit-btn py-2 px-2 border-2 border-gray-200 rounded-lg text-center text-xs font-semibold text-fx-secondary hover:border-fx-primary transition-all" data-exit="sold">Sold It</button>
            <button type="button" class="sreo-exit-btn py-2 px-2 border-2 border-gray-200 rounded-lg text-center text-xs font-semibold text-fx-secondary hover:border-fx-primary transition-all" data-exit="rented">Rented It</button>
            <button type="button" class="sreo-exit-btn py-2 px-2 border-2 border-gray-200 rounded-lg text-center text-xs font-semibold text-fx-secondary hover:border-fx-primary transition-all" data-exit="listed">Currently Listed</button>
          </div>
        </div>
        <div class="sreo-exit-sold hidden grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label class="block text-xs font-semibold text-gray-600 mb-1">Sale Date</label>
            <input type="date" class="sreo-sale-date w-full py-2.5 px-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-fx-primary text-sm">
          </div>
          <div>
            <label class="block text-xs font-semibold text-gray-600 mb-1">Sales Price</label>
            <div class="relative">
              <span class="absolute left-3 top-2.5 text-gray-400 text-sm">$</span>
              <input type="text" inputmode="numeric" class="sreo-sales-price currency-input w-full pl-7 pr-3 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-fx-primary text-sm" placeholder="350,000">
            </div>
          </div>
        </div>
        <div class="sreo-exit-rented hidden">
          <label class="block text-xs font-semibold text-gray-600 mb-1">Leased Date</label>
          <input type="date" class="sreo-leased-date w-full py-2.5 px-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-fx-primary text-sm">
        </div>
        <div class="sreo-exit-listed hidden">
          <label class="block text-xs font-semibold text-gray-600 mb-1">Listing Price</label>
          <div class="relative">
            <span class="absolute left-3 top-2.5 text-gray-400 text-sm">$</span>
            <input type="text" inputmode="numeric" class="sreo-listing-price currency-input w-full pl-7 pr-3 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-fx-primary text-sm" placeholder="375,000">
          </div>
        </div>
      </div>
    `;
    container.appendChild(div);

    // Wire remove button
    div.querySelector('.sreo-remove').addEventListener('click', () => div.remove());

    // Wire exit type card selection
    div.querySelectorAll('.sreo-exit-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        div.querySelectorAll('.sreo-exit-btn').forEach(b => {
          b.classList.remove('border-fx-primary', 'bg-fx-green-10');
          b.classList.add('border-gray-200');
        });
        this.classList.remove('border-gray-200');
        this.classList.add('border-fx-primary', 'bg-fx-green-10');
        const exitVal = this.dataset.exit;
        div.querySelector('.sreo-exit-sold').classList.toggle('hidden', exitVal !== 'sold');
        div.querySelector('.sreo-exit-rented').classList.toggle('hidden', exitVal !== 'rented');
        div.querySelector('.sreo-exit-listed').classList.toggle('hidden', exitVal !== 'listed');
      });
    });

    // Wire currency formatting on dynamic inputs
    div.querySelectorAll('.currency-input').forEach(formatCurrencyInput);

    // Pre-fill if restoring from draft
    if (data) {
      div.querySelector('.sreo-address').value = data.address || '';
      div.querySelector('.sreo-purchase-price').value = data.purchasePrice ? parseInt(data.purchasePrice, 10).toLocaleString('en-US') : '';
      div.querySelector('.sreo-rehab-amount').value = data.rehabAmount ? parseInt(data.rehabAmount, 10).toLocaleString('en-US') : '';
      if (data.exitType) {
        const exitBtn = div.querySelector(`.sreo-exit-btn[data-exit="${data.exitType}"]`);
        if (exitBtn) exitBtn.click();
      }
      if (data.saleDate) div.querySelector('.sreo-sale-date').value = data.saleDate;
      if (data.salesPrice) div.querySelector('.sreo-sales-price').value = parseInt(data.salesPrice, 10).toLocaleString('en-US');
      if (data.leasedDate) div.querySelector('.sreo-leased-date').value = data.leasedDate;
      if (data.listingPrice) div.querySelector('.sreo-listing-price').value = parseInt(data.listingPrice, 10).toLocaleString('en-US');
    }
  }

  function getSreoData() {
    return Array.from(document.querySelectorAll('.sreo-entry')).map(entry => {
      const selectedExit = entry.querySelector('.sreo-exit-btn.border-fx-primary');
      const exitType = selectedExit ? selectedExit.dataset.exit : '';
      const data = {
        address: entry.querySelector('.sreo-address').value.trim(),
        exitType: exitType,
        purchasePrice: entry.querySelector('.sreo-purchase-price').value.replace(/[^\d]/g, ''),
        rehabAmount: entry.querySelector('.sreo-rehab-amount').value.replace(/[^\d]/g, '')
      };
      if (exitType === 'sold') {
        data.saleDate = entry.querySelector('.sreo-sale-date').value;
        data.salesPrice = entry.querySelector('.sreo-sales-price').value.replace(/[^\d]/g, '');
      } else if (exitType === 'rented') {
        data.leasedDate = entry.querySelector('.sreo-leased-date').value;
      } else if (exitType === 'listed') {
        data.listingPrice = entry.querySelector('.sreo-listing-price').value.replace(/[^\d]/g, '');
      }
      return data;
    });
  }

  document.getElementById('addSreoEntry').addEventListener('click', () => addSreoEntry());

  // Delegate input events from dynamic SREO fields to trigger auto-save
  document.getElementById('sreoEntries').addEventListener('input', function() {
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(() => {
      const draft = JSON.parse(localStorage.getItem('borrower_application_draft') || '{}');
      draft.sreoProperties = getSreoData();
      localStorage.setItem('borrower_application_draft', JSON.stringify(draft));
    }, 1000);
  });

  // ── STEP 5: Experience ──
  document.getElementById('step5Form').addEventListener('submit', function(e) {
    e.preventDefault();
    clearErrors();

    if (!state.selections.experienceTier) { showError('experienceError', 'Please select your experience level'); return; }

    const tier = state.selections.experienceTier;
    let sreoData = [];
    if (tier === '1_to_2' || tier === '3_plus') {
      sreoData = getSreoData();
      if (sreoData.length === 0) {
        showError('sreoError', 'Please add at least one completed property');
        return;
      }
      const incomplete = sreoData.some(p => !p.address || !p.exitType);
      if (incomplete) {
        showError('sreoError', 'Please fill in address and exit type for each property');
        return;
      }
    }

    state.formData.experienceTier = tier;
    state.formData.sreo = sreoData;

    goToStep(6);
  });

  // ── STEP 6: Identity & Authorization ──
  document.getElementById('step6Form').addEventListener('submit', function(e) {
    e.preventDefault();
    clearErrors();

    const ssn = document.getElementById('ssn').value.trim();
    const dob = document.getElementById('dob').value;
    const eSig = document.getElementById('eSignature').value.trim();
    const creditAuth = document.getElementById('creditAuthConsent').checked;
    const residency = state.selections.residencyStatus;

    let valid = true;
    if (!residency) { showError('residencyError', 'Please select your residency status'); valid = false; }
    if (!creditAuth) { showError('creditAuthError', 'Credit authorization is required'); valid = false; }
    if (!eSig) { showError('eSignatureError', 'Electronic signature is required'); valid = false; }
    if (!valid) return;

    state.formData.ssn = ssn;
    state.formData.dob = dob;
    state.formData.eSignature = eSig;
    state.formData.residencyStatus = residency;
    state.formData.creditAuthConsent = true;
    state.creditAuthTimestamp = new Date().toISOString();

    // Show correct document section for step 7
    document.querySelectorAll('.doc-section').forEach(el => el.classList.add('hidden'));
    const docSection = document.getElementById('docs_' + state.loanType);
    if (docSection) docSection.classList.remove('hidden');

    goToStep(7);
  });

  // ── STEP 7: Documents ──
  document.getElementById('step7Form').addEventListener('submit', async function(e) {
    e.preventDefault();
    await submitFinal();
  });

  document.getElementById('skipDocs').addEventListener('click', async function() {
    await submitFinal();
  });

  async function submitFinal() {
    // Build the full payload from client state
    const payload = {
      referenceNumber: state.referenceNumber,
      loanType: state.loanType,
      propertyType: state.propertyType,

      // Borrower
      firstName: state.formData.firstName || '',
      lastName: state.formData.lastName || '',
      email: state.formData.email || '',
      phone: state.formData.phone || '',
      dob: state.formData.dob || '',
      ssn: state.formData.ssn || '',
      residencyStatus: state.formData.residencyStatus || '',
      eSignature: state.formData.eSignature || '',

      // Property
      propertyAddress: state.formData.propertyAddress || '',
      propertyCity: state.formData.propertyCity || '',
      propertyState: state.formData.propertyState || '',
      propertyZip: state.formData.propertyZip || '',
      propertyCounty: state.formData.propertyCounty || '',
      googlePlaceId: state.formData.googlePlaceId || '',

      // Deal details
      purchasePrice: state.formData.purchasePrice || '',
      rehabBudget: state.formData.rehabBudget || '',
      arv: state.formData.arv || '',
      desiredTerm: state.formData.desiredTerm || '',
      closingDate: state.formData.closingDate || '',
      monthlyRent: state.formData.monthlyRent || '',
      currentLoanAmount: state.formData.currentLoanAmount || '',
      occupancyStatus: state.formData.occupancyStatus || '',
      existingDebt: state.formData.existingDebt || '',
      existingDebtBalance: state.formData.existingDebtBalance || '',
      estimatedValue: state.formData.estimatedValue || '',
      didRenovate: state.formData.didRenovate || '',
      renovationInvestment: state.formData.renovationInvestment || '',
      seekingCashOut: state.formData.seekingCashOut || '',

      // Experience
      experienceTier: state.formData.experienceTier || '',
      sreo: JSON.stringify(state.formData.sreo || []),

      // Consent
      tosConsent: state.formData.tosConsent ? 'true' : 'false',
      tosTimestamp: state.tosTimestamp || '',
      creditAuthConsent: state.formData.creditAuthConsent ? 'true' : 'false',
      creditAuthTimestamp: state.creditAuthTimestamp || '',

      // Tracking
      utmSource: state.formData.utmSource || '',
      utmMedium: state.formData.utmMedium || '',
      utmCampaign: state.formData.utmCampaign || ''
    };

    // Disable submit buttons while processing
    const submitBtns = document.querySelectorAll('#step7Form button[type="submit"], #skipDocs');
    submitBtns.forEach(btn => { btn.disabled = true; btn.style.opacity = '0.6'; });

    const result = await apiPost('/api/apply/submit', payload);

    submitBtns.forEach(btn => { btn.disabled = false; btn.style.opacity = '1'; });

    if (!result.success) {
      alert(result.errors ? result.errors.join('\n') : 'Submission failed. Please try again or call (833) FLIPMAX.');
      return;
    }

    // Populate confirmation
    document.getElementById('confirmAddress').textContent = state.formData.propertyAddress || 'your property';
    document.getElementById('confirmPhone').textContent = state.formData.phone || '';
    document.getElementById('confirmEmail').textContent = state.formData.email || '';
    document.getElementById('confirmRef').textContent = state.referenceNumber || 'FM-PENDING';

    localStorage.removeItem('borrower_application_draft');
    localStorage.removeItem('preapproval_contact_info');

    if (typeof gtag === 'function') {
      gtag('event', 'application_submitted', {
        loan_type: state.loanType,
        reference_number: state.referenceNumber
      });
    }
    if (typeof fbq === 'function') {
      fbq('track', 'SubmitApplication', { content_category: state.loanType }, { eventID: state.referenceNumber });
    }

    goToStep(8); // confirmation
  }

  // ── Phone Formatting ──
  const phoneInput = document.getElementById('phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function(e) {
      let v = e.target.value.replace(/\D/g, '');
      if (v.length > 10) v = v.substring(0, 10);
      if (v.length >= 6) {
        e.target.value = `(${v.substring(0, 3)}) ${v.substring(3, 6)}-${v.substring(6)}`;
      } else if (v.length >= 3) {
        e.target.value = `(${v.substring(0, 3)}) ${v.substring(3)}`;
      }
    });
  }

  // ── Currency Formatting ──
  function formatCurrencyInput(input) {
    input.addEventListener('input', function() {
      let v = this.value.replace(/[^\d]/g, '');
      if (v) this.value = parseInt(v, 10).toLocaleString('en-US');
    });
  }
  document.querySelectorAll('.currency-input').forEach(formatCurrencyInput);

  // ── SSN Formatting ──
  const ssnInput = document.getElementById('ssn');
  if (ssnInput) {
    ssnInput.addEventListener('input', function(e) {
      let v = e.target.value.replace(/\D/g, '');
      if (v.length > 9) v = v.substring(0, 9);
      if (v.length >= 5) {
        e.target.value = `${v.substring(0, 3)}-${v.substring(3, 5)}-${v.substring(5)}`;
      } else if (v.length >= 3) {
        e.target.value = `${v.substring(0, 3)}-${v.substring(3)}`;
      }
    });
  }

  // ── Closing Date min = today ──
  const cd = document.getElementById('closingDate');
  if (cd) cd.setAttribute('min', new Date().toISOString().split('T')[0]);

  // ── File Upload Zones ──
  document.querySelectorAll('.file-drop-zone').forEach(zone => {
    const input = zone.querySelector('input[type="file"]');
    if (!input) return;
    zone.addEventListener('click', () => input.click());
    zone.addEventListener('dragover', (e) => { e.preventDefault(); zone.classList.add('border-fx-primary', 'bg-fx-green-10'); });
    zone.addEventListener('dragleave', () => { zone.classList.remove('border-fx-primary', 'bg-fx-green-10'); });
    zone.addEventListener('drop', (e) => {
      e.preventDefault();
      zone.classList.remove('border-fx-primary', 'bg-fx-green-10');
      input.files = e.dataTransfer.files;
      input.dispatchEvent(new Event('change'));
    });
    input.addEventListener('change', function() {
      const display = zone.parentElement.querySelector('.file-name-display');
      if (display && this.files.length > 0) {
        display.textContent = Array.from(this.files).map(f => f.name).join(', ');
      }
    });
  });

  // ID upload zone
  const idZone = document.getElementById('idUploadZone');
  const idInput = document.getElementById('idUpload');
  if (idZone && idInput) {
    idZone.addEventListener('click', () => idInput.click());
    idInput.addEventListener('change', function() {
      const nameEl = document.getElementById('idFileName');
      if (nameEl && this.files.length > 0) {
        nameEl.textContent = 'Selected: ' + this.files[0].name;
      }
    });
  }

  // ── Auto-save Draft ──
  document.querySelectorAll('input, textarea, select').forEach(input => {
    input.addEventListener('input', function() {
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(() => {
        const draft = {
          loanType: state.loanType,
          propertyType: state.propertyType,
          referenceNumber: state.referenceNumber,
          currentStep: state.currentStep,
          selections: state.selections,
          formData: state.formData,
          tosTimestamp: state.tosTimestamp,
          creditAuthTimestamp: state.creditAuthTimestamp,
          fields: {},
          sreoProperties: getSreoData()
        };
        document.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="date"], textarea').forEach(el => {
          if (el.id && el.value) draft.fields[el.id] = el.value;
        });
        localStorage.setItem('borrower_application_draft', JSON.stringify(draft));
      }, 1000);
    });
  });

  // ── Restore Draft ──
  try {
    const draft = JSON.parse(localStorage.getItem('borrower_application_draft') || 'null');
    if (draft && draft.referenceNumber) {
      state.referenceNumber = draft.referenceNumber;
      state.loanType = draft.loanType;
      state.propertyType = draft.propertyType;
      state.selections = draft.selections || {};
      state.formData = draft.formData || {};
      state.tosTimestamp = draft.tosTimestamp || null;
      state.creditAuthTimestamp = draft.creditAuthTimestamp || null;

      // Restore field values
      if (draft.fields) {
        Object.entries(draft.fields).forEach(([id, val]) => {
          const el = document.getElementById(id);
          if (el) el.value = val;
        });
      }

      // Restore option card visual states
      Object.entries(state.selections).forEach(([key, val]) => {
        document.querySelectorAll(`.option-card[data-value="${val}"]`).forEach(card => {
          card.classList.remove('border-gray-200');
          card.classList.add('border-fx-primary', 'bg-fx-green-10');
        });
      });

      // Restore SREO entries
      if (draft.sreoProperties && draft.sreoProperties.length > 0) {
        const tier = state.selections.experienceTier;
        if (tier === '1_to_2' || tier === '3_plus') {
          document.getElementById('sreoSection').classList.remove('hidden');
          draft.sreoProperties.forEach(p => addSreoEntry(p));
        }
      }
    }
  } catch (e) {}

  // ── Prefill from Deal Sizer (/quote) handoff ──
  // Only when no in-progress draft was restored, and only into empty fields.
  try {
    const draftExists = !!(JSON.parse(localStorage.getItem('borrower_application_draft') || 'null') || {}).referenceNumber;
    const handoff = JSON.parse(localStorage.getItem('flipmax_sizer_handoff') || 'null');
    const fresh = handoff && handoff.inputs && Date.now() - (handoff.savedAt || 0) < 24 * 60 * 60 * 1000;
    if (!draftExists && fresh) {
      const inputs = handoff.inputs;
      const loanTypeValue = { guc: 'ground_up', dscr: 'rental_dscr' }[inputs.deal_type] || 'fix_and_flip';
      const isGroundUp = loanTypeValue === 'ground_up';
      const loanCard = document.querySelector('#loanTypeCards .option-card[data-value="' + loanTypeValue + '"]');
      if (loanCard && !state.selections.loanType) loanCard.click();
      const propCard = inputs.property_type && document.querySelector('#propertyTypeCards .option-card[data-value="' + inputs.property_type + '"]');
      if (propCard && !state.selections.propertyType) propCard.click();

      const fillCurrency = (id, value) => {
        const el = document.getElementById(id);
        if (el && !el.value && value != null && !isNaN(Number(value))) {
          el.value = Math.round(Number(value)).toLocaleString('en-US');
        }
      };
      if (isGroundUp) {
        fillCurrency('lotPurchasePrice', inputs.purchase_price);
        fillCurrency('constructionBudget', inputs.renovation_budget);
        fillCurrency('completedValue', inputs.arv);
      } else {
        fillCurrency('purchasePrice', inputs.purchase_price);
        fillCurrency('rehabBudget', inputs.renovation_budget);
        fillCurrency('arv', inputs.arv);
      }
      const addressEl = document.getElementById('propertyAddress');
      if (addressEl && !addressEl.value && inputs.address) addressEl.value = inputs.address;
      const cityEl = document.getElementById('propertyCity');
      if (cityEl && !cityEl.value && inputs.city) cityEl.value = inputs.city;
      const stateEl = document.getElementById('propertyState');
      if (stateEl && !stateEl.value && inputs.state) stateEl.value = inputs.state;
      const zipEl = document.getElementById('propertyZip');
      if (zipEl && !zipEl.value && inputs.zip) zipEl.value = inputs.zip;

      if (typeof gtag === 'function') gtag('event', 'sizer_prefill_applied', { loan_type: loanTypeValue });
    }
  } catch (e) {}

  // ── Abandonment Tracking ──
  window.addEventListener('beforeunload', function() {
    if (state.currentStep > 1 && state.currentStep < 8 && typeof gtag === 'function') {
      gtag('event', 'form_abandoned', {
        step_number: state.currentStep,
        loan_type: state.loanType,
        reference_number: state.referenceNumber
      });
    }
  });

  // ── Google Places Autocomplete ──
  let placesLoaded = false;
  const origGoToStep = goToStep;

  window.fxForm.goToStep = function(n) {
    origGoToStep(n);
    if (n === 3 && !placesLoaded) {
      placesLoaded = true;
      loadGooglePlaces();
    }
  };

  function loadGooglePlaces() {
    const key = document.querySelector('meta[name="google-places-key"]');
    if (!key || !key.content) return;

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key.content}&libraries=places&callback=initGooglePlaces`;
    script.async = true;
    document.head.appendChild(script);

    window.initGooglePlaces = function() {
      const input = document.getElementById('propertyAddress');
      if (!input) return;

      const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['address'],
        componentRestrictions: { country: 'us' }
      });

      autocomplete.addListener('place_changed', function() {
        const place = autocomplete.getPlace();
        if (!place.address_components) return;

        document.getElementById('googlePlaceId').value = place.place_id || '';
        document.getElementById('propertyAddress').value = place.formatted_address || '';

        const components = place.address_components;
        components.forEach(c => {
          if (c.types.includes('locality')) document.getElementById('propertyCity').value = c.long_name;
          if (c.types.includes('administrative_area_level_1')) document.getElementById('propertyState').value = c.short_name;
          if (c.types.includes('postal_code')) document.getElementById('propertyZip').value = c.long_name;
          if (c.types.includes('administrative_area_level_2')) document.getElementById('propertyCounty').value = c.long_name;
        });
      });
    };
  }
});
